import axios from 'axios'
import Swal from 'sweetalert2';
import { getCurrentTime, today } from '../../../Js/Date';
import {HEADERS} from '../../UrlAndPaths'
import { getShiftStatusAPICAll } from './viewShiftAPI';
import { setSubmitLoading } from '../../../Redux/Dashboard/mainDashBoardSlice';
import store from '../../../Redux/store';
import db from '../../../offline/db';

let branchId=localStorage.getItem('branchId')
//shift start api call
export const startManualShiftAPICall=async(
    body,
    setShiftBtnState,
    shiftBtnState,
    handleReset,
    handleStart,
    setErrorSnack,
    setErrorMsg
    )=>{
    store.dispatch(setSubmitLoading(true))
    await axios.post("settings/startmanualshift",body,HEADERS)
    .then((res)=>{
        if(res.status===200){
            handleReset()
            handleStart()
            setShiftBtnState(!shiftBtnState);
            getShiftStatusAPICAll({branchId,curTime:`${today} ${getCurrentTime()}`})
            store.dispatch(setSubmitLoading(false))

        }
    })
    .catch((err)=>{
        store.dispatch(setSubmitLoading(false))
        if(err.response.status === 500){
            setErrorMsg('Internal Server error !')
          }
          else{
            setErrorMsg(err?.response?.data || "Network connection failed !!")
          }
        setErrorSnack(true)

    })
}

// shift end api call
export const endManualShiftAPICall= async (
    body,
    handlePause,
    setShiftEndPasswordDialog,
    setShiftBtnState,
    shiftBtnState,
    setErrorSnack,
    setErrorMsg
    )=>{
    store.dispatch(setSubmitLoading(true))
    
    try {
        const res = await axios.post("settings/endmanualshift", body, HEADERS);
        
        if(res.status === 200){
            handlePause()
            setShiftEndPasswordDialog(false);
            setShiftBtnState(!shiftBtnState);
            localStorage.removeItem('shiftStatus')
            
            // Clear any pending shift end from queue (in case it was queued before)
            const shiftId = body.shiftId || body._id;
            if (shiftId) {
                await db.removeShiftEnd(shiftId);
                await db.clearLocalShiftStatus(body.branchId);
            }
            
            // Refresh active shift status instead of reloading the page
            getShiftStatusAPICAll({branchId, curTime:`${today} ${getCurrentTime()}`})
            store.dispatch(setSubmitLoading(false))
        }
    } catch (err) {
        store.dispatch(setSubmitLoading(false))
        
        // Check if this is a network error or server unreachable
        const isNetworkError = !err.response || err.code === 'ERR_NETWORK' || err.message === 'Network Error';
        const isServerError = err.response?.status >= 500;
        
        if (isNetworkError || isServerError) {
            console.log('🔴 Shift end failed due to network/server error, queuing for later...');
            
            try {
                // Queue the shift end request
                const shiftId = body.shiftId || body._id;
                await db.queueShiftEnd({
                    ...body,
                    shiftId
                });
                
                // Store local shift status for UI
                await db.setLocalShiftStatus(body.branchId, 'PENDING_END', {
                    shiftId,
                    endDate: body.endDate,
                    queuedAt: Date.now()
                });
                
                // Close dialog and update UI
                setShiftEndPasswordDialog(false);
                handlePause();
                setShiftBtnState(!shiftBtnState);
                localStorage.setItem('shiftStatus', 'PENDING_END');
                
                // Show warning to user
                Swal.fire({
                    icon: 'warning',
                    title: 'Shift End Queued',
                    html: `
                        <p>Your shift end request has been saved locally.</p>
                        <p style="color: #666; font-size: 14px; margin-top: 10px;">
                            ⚠️ The accounting entries will be created when the server is available.
                        </p>
                        <p style="color: #666; font-size: 14px;">
                            Please do not start a new shift until this is synced.
                        </p>
                    `,
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#f0ad4e'
                });
                
                store.dispatch(setSubmitLoading(false))
                return; // Exit early - don't show error
            } catch (queueError) {
                console.error('❌ Failed to queue shift end:', queueError);
                setErrorMsg('Failed to save shift end request. Please try again.');
                setErrorSnack(true);
                return;
            }
        }
        
        // Handle other errors normally
        if(err.response?.status === 500){
            setErrorMsg('Internal Server error !')
        }
        else if(err.response?.status === 403){
            setErrorMsg('Journal Entry mismatch!!')
        }
        else if(err.response?.status === 406){
            // Not acceptable - usually means pending orders exist
            setErrorMsg(err?.response?.data || 'Cannot end shift - pending orders exist')
        }
        else{
            setErrorMsg(err?.response?.data || "Network connection failed !!")
        }
        setErrorSnack(true)
        
        // Also refresh active shift to show who is still checked-in
        getShiftStatusAPICAll({branchId, curTime:`${today} ${getCurrentTime()}`})
    }
}

export const addShiftDenominationAPICall=async(body,denominationUpdated)=>{
    await axios.post("settings/addDenomination",body,HEADERS)
        .then((res)=>{
            if(res.status===200){
                denominationUpdated()
            }
        })
        .catch((err)=>{
            console.error(err.response.status);
        })
}

// 